import * as React from "react"
import { HelpCircle } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip"

/**
 * HelpTooltip - A question mark icon with tooltip help text
 * 
 * Usage:
 * <HelpTooltip text="This is the help text" />
 * <HelpTooltip>
 *   <p>Multi-line help text</p>
 *   <ul><li>Item 1</li></ul>
 * </HelpTooltip>
 */
export function HelpTooltip({ text, children, className = "", side = "top" }) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <HelpCircle 
            className={`h-3.5 w-3.5 text-muted-foreground/60 hover:text-muted-foreground cursor-help inline-block ml-1 ${className}`}
          />
        </TooltipTrigger>
        <TooltipContent 
          side={side} 
          className="max-w-xs text-xs leading-relaxed bg-slate-900 text-slate-100 p-2"
        >
          {children || text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

/**
 * Column header with help tooltip
 */
export function ColumnHeader({ children, help, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {children}
      {help && <HelpTooltip text={help} />}
    </span>
  )
}
